module.exports = __webpack_public_path__ + "static/media/letter.87f3cf76.svg";